import { LoyaltyBadgeWrapper } from '@/app/common/components/LoyaltyBadge/styled.ts';
import type { LoyaltyProBadgeProps } from '@lmn/lmn-components';
import { LoyaltyProBadge } from '@lmn/lmn-components';

type LoyaltyBadgeProps = {
  style?: React.CSSProperties;
} & LoyaltyProBadgeProps;

const LoyaltyBadge = ({ label, className, style }: LoyaltyBadgeProps) => (
  <LoyaltyBadgeWrapper style={style} isEmpty={!label}>
    <LoyaltyProBadge label={label} className={className} />
  </LoyaltyBadgeWrapper>
);

export default LoyaltyBadge;
